import { ReduxState } from '../..';
import { IShownUserPolicy } from './types';

export const selectFTUShownUserIds = (state: ReduxState): string[] => state.applicationState.ftuShownUserIds;
export const selectFTUShownUserPolicyIds = (state: ReduxState): IShownUserPolicy[] =>
    state.applicationState.ftuShownUserPolicyIds;
export const selectCookiesEnabled = (state: ReduxState): boolean | null =>
    state.applicationState.cookiesEnabled ?? null;
